import {useChangeFunctions} from '@domain/shifthandover'
import {RemoveFilterButton} from '@widgets/common-filters'
import React from 'react'
import {useTranslation} from 'react-i18next'

import {DesktopFilterOptionsKeys} from '../cockpit-filters'
import {SHIFT_EVENT_FILTERS_WIDGET_NAMESPACE} from '../consts'

import {FilterDropDown} from './FilterDropDown'
import type {CommonFilterDropDownProps} from './FilterDropDown'
import {SelectAllButton} from './SelectAllButton'

const FunctionTitle: React.FC<{functionId?: string}> = ({functionId}) => {
  const {
    t,
    i18n: {language}
  } = useTranslation(SHIFT_EVENT_FILTERS_WIDGET_NAMESPACE)
  const {data: functions} = useChangeFunctions({language})

  const selectedFunction = functions?.find(({id}) => id === functionId)

  if (functionId && functions && selectedFunction) {
    return (
      <>
        {t(`shiftEvent.function.${selectedFunction.code}`, {defaultValue: selectedFunction.name})}
      </>
    )
  }

  return <>{functionId || ''}</>
}

export const FunctionsFilterDropDown: React.FC<CommonFilterDropDownProps<string>> = (props) => {
  const {
    i18n: {language}
  } = useTranslation(SHIFT_EVENT_FILTERS_WIDGET_NAMESPACE)
  const {data: functions = []} = useChangeFunctions({language})
  const {selectAll} = props
  const options = functions.map(({id}) => id)
  const fieldKeyName: DesktopFilterOptionsKeys = 'changeFunctions'

  return (
    <FilterDropDown
      {...props}
      options={options}
      keyName="function"
      fullWidth={false}
      renderValue={(value: string[]) => {
        return value.map((val) => functions.find(({id}) => id === val)?.code || val || '').join(',')
      }}
      customTemplate={(key) => <FunctionTitle functionId={key} />}
      customDropDownFooter={() =>
        props.isCollapsible ? null : (
          <>
            <SelectAllButton
              keyName={fieldKeyName}
              selectAll={() => selectAll && selectAll(fieldKeyName, options)}
            />
            <RemoveFilterButton keyName={fieldKeyName} removeFilter={props.removeFilter} />
          </>
        )
      }
    />
  )
}
